import { get } from "lodash";
import { MdClose } from "react-icons/md";
import { DATE_FORMAT } from "utils/constants";
import Button from "../../Components/Button";
import Input from "../../Components/Input";
import { buildMappedProduct } from "../../mappedProduct";
import ProductCard from "./ProductCard";
const RelatedPerson = ({
  title,
  contact,
  onDelete,
  TRANSLATION,
  products,
  selectedProducts,
  setSelectedProducts,
  disabledDate,
  defaultPickerValue,
  inputProps,
}) => {
  return (
    <div className="relatedPersons__content">
      <div className="relatedPersons__content--header">
        <span className="relatedPersons__content--header__title">{title}</span>
        <Button size="medium" type={"danger-light"} onClick={onDelete}>
          <MdClose size={20} />
          Retirer
        </Button>
      </div>
      <div className="relatedPersons__content--form">
        <Input
          type="date"
          label={TRANSLATION.BIRTH_DATE.LABEL}
          placeholder={"JJ / MM / AAAA"}
          format={DATE_FORMAT}
          showToday={false}
          defaultPickerValue={defaultPickerValue}
          disabledDate={disabledDate}
          {...inputProps}
        />
      </div>
      <div className="relatedPersons__content--products">
        {products.map((insurancePlan, i) => {
          return (
            <ProductCard
              key={`product.insurancePlan.${i}`}
              isSelected={
                selectedProducts[get(contact, "id")]?.id ===
                get(insurancePlan, "id")
              }
              selectProduct={() =>
                setSelectedProducts((prev) => ({
                  ...prev,
                  [get(contact, "id")]: buildMappedProduct(insurancePlan),
                }))
              }
              id={get(insurancePlan, "id")}
              name={get(insurancePlan, "name")}
              alias={get(insurancePlan, "alias")}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RelatedPerson;
